import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabaseClient'
import { getSubdomainFromHost, isAllowedSubdomain } from '../lib/hostOrg'
import OrgNotFound from '../Pages/OrgNotFound.jsx'

export default function SubdomainGate({ children }) {
  const [status, setStatus] = useState('checking') // 'checking' | 'allowed' | 'blocked'

  useEffect(() => {
    let active = true
    async function check() {
      try {
        const sub = getSubdomainFromHost(window.location.hostname)
        // Allow when no subdomain (localhost/preview) or reserved subdomains
        const reserved = ['learn', 'www', 'assessments']
        if (!sub || reserved.includes(sub)) {
          if (active) setStatus('allowed')
          return
        }
        const res = await isAllowedSubdomain(sub, supabase)
        if (active) setStatus(res.ok ? 'allowed' : 'blocked')
      } catch {
        if (active) setStatus('allowed')
      }
    }
    check()
    return () => { active = false }
  }, [])

  if (status === 'checking') return null
  if (status === 'blocked') return <OrgNotFound />
  return children
}


